import React, { Component } from 'react';

class HtmlRenderer extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.loadedScripts = {}; // Tracks already-loaded scripts to avoid duplication
  }

  componentDidMount() {
    this.setHtmlAndLoadScripts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.html !== this.props.html) {
      this.setHtmlAndLoadScripts();
    }
  }

  setHtmlAndLoadScripts() {
    if (this.containerRef.current) {
      // Inject HTML
      this.containerRef.current.innerHTML = this.props.html;

      // Find all <script src="..."> tags
      const scriptTags = this.containerRef.current.querySelectorAll('script[src]');

      scriptTags.forEach((tag) => {
        const src = tag.getAttribute('src');

        // Skip if script already loaded
        if (this.loadedScripts[src]) return;

        // Create and append new script tag
        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        document.body.appendChild(script);
        this.loadedScripts[src] = true;
      });
    }
  }

  render() {
    return <div ref={this.containerRef} className={'html-renderer'} />;
  }
}

export default HtmlRenderer;



// WEBPACK FOOTER //
// ./src/js/components/html-renderer.js